import React, { createContext, useContext, useState, useEffect } from 'react';
import { useMessage } from './MessageContext';
import { getUserDetail } from '../apis/apiList/userApi';

// Create the app context
const AppContext = createContext();

// Provider for app state
export const AppProvider = ({ children }) => {
  const [userDetails, setUserDetails] = useState('');
  const {showMessage } = useMessage();

  useEffect(() => {

    async function fetchUserDetails(user) {
      try {
        const userDetail = await getUserDetail(user._id);
        console.log('user fetch', userDetail);
        setUserDetails(userDetail.user);
      } catch (error) {
        console.log('error', error);
      }
    } 

    const storedUser = localStorage.getItem('user-snapshotvideos');

    if (storedUser) {
      let user = JSON.parse(storedUser)
      setUserDetails(user);
      fetchUserDetails(user)
    }
    
  }, []);

  const login = (userInfo) => {
    setUserDetails(userInfo);
    localStorage.setItem('user-snapshotvideos', JSON.stringify(userInfo));
  };

  const logout = () => {
    setUserDetails(null);
    localStorage.removeItem('user-snapshotvideos');
  };


  return (
    <AppContext.Provider value={{
      userDetails,
      login,
      logout,
    }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook to use the app context
export const useApp = () => useContext(AppContext);